import axios from 'axios';

const API_BASE = 'https://hms.backend.hiragroupcloud.com';

const authHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchMyGroups = async () => {
  const res = await axios.get(`${API_BASE}/api/chat/groups`, {
    headers: authHeaders()
  });
  return res.data;
};

export const createGroup = async ({ name, memberUserIds }) => {
  const res = await axios.post(
    `${API_BASE}/api/chat/groups`,
    { name, memberUserIds },
    { headers: authHeaders() }
  );
  return res.data;
};

export const fetchGroupMessages = async (groupId, { before, limit = 50 } = {}) => {
  const params = { limit };
  if (before) params.before = before;
  const res = await axios.get(`${API_BASE}/api/chat/groups/${groupId}/messages`, {
    headers: authHeaders(),
    params
  });
  return res.data;
};

// api/chatApi.js — sirf sendMessageHttp update karo

export const sendMessageHttp = async (groupId, text, files = [], mentionedUserIds = []) => {
  const formData = new FormData();
  if (text) formData.append('text', text);
  if (mentionedUserIds && mentionedUserIds.length > 0) {
    formData.append('mentionedUserIds', JSON.stringify(mentionedUserIds));
  }
  if (files && files.length > 0) {
    files.forEach((f) => formData.append('files', f));
  }

  const res = await axios.post(
    `${API_BASE}/api/chat/groups/${groupId}/messages`,
    formData,
    {
      headers: {
        ...authHeaders(),
        // axios automatically sets multipart Content-Type with boundary
      }
    }
  );
  return res.data;
};

export const addMembers = async (groupId, memberUserIds) => {
  const res = await axios.post(
    `${API_BASE}/api/chat/groups/${groupId}/members`,
    { memberUserIds },
    { headers: authHeaders() }
  );
  return res.data;
};

export const removeMember = async (groupId, userId) => {
  const res = await axios.delete(
    `${API_BASE}/api/chat/groups/${groupId}/members/${userId}`,
    { headers: authHeaders() }
  );
  return res.data;
};

// ✅ FIXED: /api/chat/lab-users (registered in chatRoutes.js)
export const fetchLabUsers = async () => {
  const labId =
    localStorage.getItem('userLabId') ||
    localStorage.getItem('labId') ||
    '';

  const res = await axios.get(`${API_BASE}/api/auth/labusers`, {
    headers: authHeaders(),
    params: labId ? { labId } : {}
  });
  return res.data;
};
// ✅ DM: get or create 1-to-1 conversation
export const getOrCreateDirectConversation = async (otherUserId) => {
  const res = await axios.post(
    `${API_BASE}/api/chat/dm`,
    { otherUserId },
    { headers: authHeaders() }
  );
  return res.data;
};
// api/chatApi.js — ADD at the end

// ✅ Mark messages as seen
export const markMessagesSeenApi = async (groupId, messageIds = []) => {
  const res = await axios.post(
    `${API_BASE}/api/chat/groups/${groupId}/seen`,
    { messageIds },
    { headers: authHeaders() }
  );
  return res.data;
};